export default __webpack_public_path__ + "3a21b51ce3221f7660248ce2772c6b69.svg";